export default "__VITE_ASSET__a655bbda__"